<template>
  <div ref="modalContainer"></div>
  <a-card class="content-wrapper">
    <template #title>
      <CardHeader></CardHeader>
    </template>
    <div class="body-content">
      <a-form layout="inline">
        <a-form-item label="泊位编号">
          <a-input
            v-model:value="params.code"
            placeholder="输入泊位编号"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item label="车场">
          <a-select
            v-model:value="params.parkingLotId"
            notFoundContent="暂无数据"
            style="width: 200px"
            placeholder="请选择"
            allow-clear
            @change="getParkingPlace"
          >
            <a-select-option
              v-for="item in parkingLotList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select
            v-model:value="params.state"
            notFoundContent="暂无数据"
            style="width: 200px"
            placeholder="请选择"
            allow-clear
          >
            <a-select-option
              v-for="item in placeStates"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="doQuery">
            <template #icon>
              <SearchOutlined />
            </template>
            查询
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button class="btn-success" @click="showAddModal">
            <template #icon>
              <PlusCircleOutlined />
            </template>
            添加
          </a-button>
        </a-form-item>
      </a-form>
      <div style="padding: 4px 0">
        <a-table
          row-key="id"
          table-layout="fixed"
          :data-source="dataList.list"
          :columns="columns"
          :loading="loading"
          :pagination="false"
          :scroll="{ y: 500 }"
          bordered
        >
          <template #state="{ text }">
            <a-tag :color="text == 1 ? 'red' : 'green'">
              {{ text == 1 ? "有车" : "无车" }}
            </a-tag>
          </template>
          <template #operation="{ record }">
            <div>
              <TipButton
                perm="parking:billRule:edit"
                btn-class="btn-success"
                title="编辑"
                @btnClick="showEditModal(record.id)"
              >
                <template #default>
                  <EditOutlined />
                </template>
              </TipButton>
              <TipButton
                perm="parking:billRule:del"
                btn-class="btn-danger"
                title="删除"
                @btnClick="delItem(record.id)"
              >
                <template #default>
                  <DeleteOutlined />
                </template>
              </TipButton>
            </div>
          </template>
        </a-table>
      </div>
      <a-pagination
        v-model:current="page"
        v-model:page-size="pageSize"
        :total="total"
        :show-total="total => `${total}条数据`"
        @change="currentChange"
      >
      </a-pagination>
    </div>
  </a-card>
  <add
    v-if="addShow"
    :modal-ref="$refs.modalContainer"
    @close="hideAddModal"
  ></add>
  <edit
    v-if="editShow"
    :id="currentId"
    :modal-ref="$refs.modalContainer"
    @close="hideEditModal"
  ></edit>
</template>

<script>
import CardHeader from "@/components/CardHeader";
import usePagination from "@/hooks/usePagination";
import useAddExit from "@/hooks/useAddExit";
import { onMounted } from "vue";
import Add from "@/views/Parking/Slots/components/Add";
import Edit from "@/views/Parking/Slots/components/Edit";
import useMessage from "@/hooks/useMessage";
import TipButton from "@/components/TipButton";
import { deleteParkingPlace } from "@/api/parking/parkingPlaceApi";
import useParkingPlace from "@/hooks/parking/useParkingPlace";

export default {
  name: "index",
  components: {
    Edit,
    Add,
    CardHeader,
    TipButton,
  },
  setup() {
    const {
      params,
      dataList,
      total,
      loading,
      columns,
      parkingLotList,
      loadData,
      getParkingLotList,
      placeStates,
    } = useParkingPlace();

    const { page, pageSize, currentChange, doQuery, doRefresh } =
      usePagination(loadData);

    const {
      currentId,
      addShow,
      editShow,
      showAddModal,
      showEditModal,
      hideAddModal,
      hideEditModal,
    } = useAddExit(doQuery);

    const { showConfirm, showLoading, closeLoading, showTipMessage, showErr } =
      useMessage();

    onMounted(async () => {
      getParkingLotList();
      loadData(page.value, pageSize.value);
    });

    const delItem = async id => {
      let action = await showConfirm("是否删除车位?");
      if (action) {
        await showLoading("正在删除，请稍后...");
        try {
          await deleteParkingPlace(id);
          await closeLoading();
          await showTipMessage("删除成功", "success");
          doQuery();
        } catch (e) {
          await closeLoading();
          await showErr(e);
        }
      }
    };

    return {
      parkingLotList,
      placeStates,
      params,
      page,
      pageSize,
      total,
      loading,
      currentChange,
      dataList,
      doQuery,
      doRefresh,
      columns,

      currentId,
      addShow,
      editShow,
      showEditModal,
      showAddModal,
      hideAddModal,
      hideEditModal,
      delItem,
    };
  },
};
</script>

<style scoped></style>
